import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const JobContainer = styled.div`
    background: #d3d3d3;
    position: relative;
    // height: 75vh;
    overflow: hidden;
    padding-top: 100px;

    @media screen and (min-height: 1200px) {
        height: 75vh;
    }

    @media screen and (max-height: 1060px) {
        height: 130vh;
    }

    @media screen and (max-height: 820px) {
        height: 200vh;
    }

    @media screen and (max-height: 530px) {
        height: 270vh;
    }

    @media screen and (max-height: 395px) {
        height: 400vh;
    }

    @media screen and (max-width: 480px) {
        height: 270vh;
        padding-bottom: 8rem;
    }
`

export const TitleWrapper = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    margin-top: 3rem;
    margin-bottom: 2rem;
    text-align: center;
    padding-bottom: 1rem;
    border-bottom: 2px solid black;

    @media screen and (max-width: 480px) {
		max-width: 300px;
	}

    @media screen and (max-width: 370px) {
        max-width: 220px;
        margin-top: 2rem;
    }
`

export const Title = styled.h1`
    font-size: 2.3rem;
    font-weight: bold;

    @media screen and (max-width: 480px) {
		font-size: 1.8rem;
		text-align: center;
	}

    @media screen and (max-width: 370px) {
        font-size: 1.5rem;
    }
`

export const JobWrapper = styled.div`
    position: relative;
    margin: 0 auto;
    padding: 0 24px;
    // height: 100%;
    max-width: 1400px;
    align-items: center;
`

export const ContactWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    margin-bottom: 2rem;
    text-align: center;
    padding-bottom: 1rem;

    @media screen and (max-width: 480px) {
		max-width: 270px;
	}

    @media screen and (max-width: 370px) {
        max-width: 200px;
        margin-top: 2rem;
    }
`

export const ContactLink = styled.a`
    color: #2f8eed;
`

export const ListingWrapper = styled.div`
    display: block;
    padding-bottom: 2rem;
`

export const Header = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    padding-bottom: .5rem;

    @media screen and (max-width: 480px) {
		font-size: 1.3rem;
        padding-bottom: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: 1rem;
    }
`

export const Button = styled(LinkR)`
    font-size: 18px;
    color: #2f8eed;
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        color: #000000;
        transition: all 0.3s ease-in-out;
    }

    @media screen and (max-width: 480px) {
		font-size: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: .8rem;
    }
`

export const JobWrapper2 = styled.div`
    position: relative;
    margin: 0 auto;
    padding: 0 24px;
    height: 100%;
    max-width: 1400px;
    align-items: center;
    margin-bottom: 7rem;
`

export const BulletDiv = styled.div`
    font-size: 18px;
    margin-left: 5rem;
    padding-bottom: 1.5rem;

    @media screen and (max-width: 480px) {
		font-size: 1rem;
        margin-left: 2rem;
	}

    @media screen and (max-width: 370px) {
        font-size: .8rem;
    }
`

export const Header2 = styled.h1`
    font-size: 28px;
    font-weight: bold;
    color: #000000;
    padding-bottom: 2.5rem;

    @media screen and (max-width: 480px) {
		font-size: 1.5rem;
        padding-bottom: 1rem;
	}

    @media screen and (max-width: 370px) {
        font-size: 1.2rem;
    }
`

export const Subheader = styled.h2`
    font-size: 24px;
    color: #000000;
    margin-left: 3rem;

    @media screen and (max-width: 480px) {
		font-size: 1.2rem;
        padding-left: 1.5rem;
        margin: 0 auto;
	}

    @media screen and (max-width: 370px) {
        font-size: 0.9rem;
        padding-right: 1.7rem;
        padding-left: 1.7rem;
    }
`